export enum RoutePath {
  LOGIN = '/login',
  MANAGEMENT = '/management',
  USERS = '/users',
  USER_DETAIL = '/users/:id',
  USER_GROUPS = '/user-groups',
  USER_GROUP_DETAIL = '/user-groups/:id',
  ROLES = '/roles',
  ROLE_DETAIL = '/roles/:id',
  APP = '/app-management',
  APP_DETAIL = '/app-management/:id',
  PROJECTS = '/projects',
  PROJECT_DETAIL = '/projects/:id',
  AUTH_MANAGEMENT = '/auth-management',
  GUIDE = '/guide',
  DASHBOARD = '/dashboard',
  DASHBOARD_HOME = '/home',
  DASHBOARD_HOME_PERSONAL = '/home-personal',
  DASHBOARD_RO = '/ro',
  DASHBOARD_RO_ALL = '/all',
  DASHBOARD_RO_ALL_PERSONAL = '/all-personal',
  DASHBOARD_RO_ROO = '/roo',
  DASHBOARD_RO_ROO_PERSONAL = '/roo-personal',
  DASHBOARD_RO_ROW = '/row',
  DASHBOARD_RO_ROW_PERSONAL = '/row-personal',
  DASHBOARD_RO_RO3 = '/ro3',
  DASHBOARD_RO_RO3_PERSONAL = '/ro3-personal',
  DASHBOARD_RO_ROOC = '/rooc',
  DASHBOARD_RO_ROOC_PERSONAL = '/rooc-personal',
  DASHBOARD_TY = '/ty',
  DASHBOARD_TY_ALL = '/all',
  DASHBOARD_TY_ALL_PERSONAL = '/all-personal',
  DASHBOARD_TY_ACT = '/act',
  DASHBOARD_TY_ACT_PERSONAL = '/act-personal',
  DASHBOARD_TY_JJSG = '/jjsg',
  DASHBOARD_TY_JJSG_PERSONAL = '/jjsg-personal',
  DASHBOARD_TY_MS = '/ms',
  DASHBOARD_TY_MS_PERSONAL = '/ms-personal',
  DASHBOARD_KOF = '/kof',
  DASHBOARD_KOF_ALL = '/all',
  DASHBOARD_KOF_ALL_PERSONAL = '/all-personal',
  DASHBOARD_KOF_PERSONAL = '/kof-personal',
  DASHBOARD_PRIVATE = '/private',
  DASHBOARD_NO_AUTH = '/no-auth',
}

export const RouteName = {
  [RoutePath.LOGIN]: '登录',
  [RoutePath.MANAGEMENT]: '管理中心',
  [RoutePath.USERS]: '用户',
  [RoutePath.USER_DETAIL]: '用户详情',
  [RoutePath.USER_GROUPS]: '用户组',
  [RoutePath.USER_GROUP_DETAIL]: '用户组详情',
  [RoutePath.ROLES]: '角色',
  [RoutePath.ROLE_DETAIL]: '角色详情',
  [RoutePath.APP]: '应用',
  [RoutePath.APP_DETAIL]: '应用详情',
  [RoutePath.PROJECTS]: '项目',
  [RoutePath.PROJECT_DETAIL]: '项目详情',
  [RoutePath.AUTH_MANAGEMENT]: '主系统权限',
  [RoutePath.GUIDE]: '导航中心',
  [RoutePath.DASHBOARD]: '看板',
  [RoutePath.DASHBOARD_HOME]: '全公司',
  [RoutePath.DASHBOARD_HOME_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_RO]: 'RO',
  [RoutePath.DASHBOARD_RO_ALL]: '全部',
  [RoutePath.DASHBOARD_RO_ALL_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_RO_ROO]: 'ROO',
  [RoutePath.DASHBOARD_RO_ROO_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_RO_ROW]: 'ROW',
  [RoutePath.DASHBOARD_RO_ROW_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_RO_RO3]: 'RO3',
  [RoutePath.DASHBOARD_KOF]: '拳皇',
  [RoutePath.DASHBOARD_KOF_PERSONAL]: '拳皇-个人',
  [RoutePath.DASHBOARD_RO_ROOC]: 'ROOC',
  [RoutePath.DASHBOARD_RO_ROOC_PERSONAL]: 'ROOC',
  [RoutePath.DASHBOARD_RO_RO3_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_TY]: 'TY',
  [RoutePath.DASHBOARD_TY_ACT]: 'ACT',
  [RoutePath.DASHBOARD_TY_ACT_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_TY_JJSG]: 'JJSG',
  [RoutePath.DASHBOARD_TY_JJSG_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_TY_MS]: 'MS',
  [RoutePath.DASHBOARD_TY_MS_PERSONAL]: '个人',
  [RoutePath.DASHBOARD_PRIVATE]: '个人看板',
  [RoutePath.DASHBOARD_NO_AUTH]: '无权限',
};
